import { Card, CardContent, CardHeader, Divider, List, ListItem, ListItemText, Stack, Typography } from '@mui/material';

import CardTitleHeader from 'components/v2/card/CardTitleHeader';
import ShowSpin from 'components/v2/spin/ShowSpin';
import { MODAL_ID, MODALS_STORE } from 'constants/ui/modal';
import { useLocalization } from 'localization';
import { colors } from 'theme/mui/colors';
import NewsModal from '../servicesmodal/news/NewsModal';
import { INewsDto } from 'api/news/dtos';

type Props = {
  data?: INewsDto[];
  loading?: boolean;
};

const Notifications = (props: Props) => {
  const { data, loading = false } = props;
  const { t } = useLocalization();
  const { toggleModal, isModalOpen, setModalData } = MODALS_STORE.news();

  const handleOpenNews = (index: number) => {
    toggleModal(MODAL_ID.NEWS);
    setModalData(MODAL_ID.NEWS, {
      content: data?.[index]?.content ?? '',
      date: data?.[index]?.date ?? '',
      title: data?.[index]?.title ?? '',
    });
  };

  return (
    <Card
      sx={{
        flexDirection: 'column',
        width: '100%',
        minHeight: {
          xs: '15rem',
        },
      }}
    >
      <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
        <ShowSpin when={loading} size={16}>
          <Stack gap={2.5}>
            <CardHeader title={<CardTitleHeader title={t('navigation.secondaryMenu.notifications')} />} />
            <Divider />
            <List sx={{ width: '100%' }}>
              {data?.length ? (
                data.map((news, index) => {
                  return (
                    <ListItem
                      key={news.id}
                      alignItems="flex-start"
                      onMouseEnter={e => {
                        e.currentTarget.style.backgroundColor = colors.gray[100];
                      }}
                      onMouseLeave={e => {
                        e.currentTarget.style.backgroundColor = colors.base.white;
                      }}
                      onClick={() => handleOpenNews(index)}
                    >
                      <ListItemText
                        sx={{ cursor: 'pointer' }}
                        primary={<Typography variant="subtitle2">{news.date}</Typography>}
                        secondary={
                          <Stack>
                            <Typography variant="subtitle1">{news.title}</Typography>
                            <Typography variant="caption">{news.teaser}</Typography>
                          </Stack>
                        }
                      />
                    </ListItem>
                  );
                })
              ) : (
                <Stack justifyContent="center" alignItems="center">
                  <Typography variant="caption">{t('common.terms.noData')}</Typography>
                </Stack>
              )}
            </List>
            {isModalOpen(MODAL_ID.NEWS) && <NewsModal />}
            <Divider />
          </Stack>
        </ShowSpin>
      </CardContent>
    </Card>
  );
};

export default Notifications;
